const deptId = 100 ;
const severApi = 'http://192.168.31.107:8080';

export default
{
  deptId,//区县ID
  severApi,//全局API
}



// WEBPACK FOOTER //
// ./src/utils/global.js